import React from 'react';
import { EIconTypes } from 'constants/Icons';
import { EButtonSizesPX, EButtonVariants } from 'constants/Buttons';
import { useNavigate } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { Divider, Menu } from '@mui/material';
import Icon from 'components/atoms/Icon/Icon';
import { useAuth } from 'models/authContext';
import { SessionStorageKeys } from 'constants/Storage';
import { MenuItemStyle, StyledProfileButton } from './styles';

const ProfileNavItem = () => {
  const navigate = useNavigate();
  const { logOut } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <StyledProfileButton
        variant={EButtonVariants.contained}
        icon={EIconTypes.person}
        sizePX={EButtonSizesPX.px40}
        onClick={handleClick}
      />

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiList-root': {
                padding: 0,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItemStyle
          onClick={() => {
            handleClose();
            navigate(ERouteLinks.MyProfile);
          }}
        >
          <Icon type={EIconTypes.left} />
          My Profile
        </MenuItemStyle>
        <Divider
          sx={{
            '&.MuiDivider-root': {
              margin: '0 !important',
            },
          }}
        />
        <MenuItemStyle
          onClick={() => {
            handleClose();
            logOut(() => {
              navigate(ERouteLinks.Auth, {
                state: { type: window.sessionStorage.getItem(SessionStorageKeys.type) },
              });
            });
          }}
        >
          <Icon type={EIconTypes.logout} />
          Logout
        </MenuItemStyle>
      </Menu>
    </>
  );
};

export { ProfileNavItem };
